<template>
  <div class="orderpage order-task-detail-page theme-green">
    <div class="chart-block">
      <div class="container">
        <img :src="'/static/theme-green/images/order/rwxq.png'" class="titl">
        <div class="hd">
          <img :src="'/static/theme-green/images/order/btn-fhdd.png'" @click="returnBack()" class="btn-return">
          <div class="search">
            <input type="text" v-model="taskNumber" placeholder="请输入任务编号">
            <span class="sbtn" @click="getTaskList()">查询</span>
          </div>
        </div>
        <div class="bd">
          <div class="dt-tab">
            <span v-for="item in taskTypes" :class="[{'active': item.value==taskCurrentType}]" @click="taskTabSwitch(item)" v-text="item.label"></span>
          </div>
          <div class="content">
            <div class="list-block">
              <template v-for="osd in taskStatusData">
                <div class="litem" v-for="item in taskTypes" v-if="item.value==taskCurrentType">
                  <div :class="['status', 'transition', {'active': taskInfo.TaskState==osd.value}]" @click="statusSwitch(osd.value, item)"><span><span v-text="osd.label"></span>（<span v-text="item.data&&item.data[osd.value]?item.data[osd.value].length:0"></span>个）</span><i :class="[{'i-arrow-right': showStatus!=osd.value||!(item.data&&item.data[osd.value]&&item.data[osd.value].length)}, {'i-arrow-down': showStatus==osd.value&&(item.data&&item.data[osd.value]&&item.data[osd.value].length)}]"></i></div>
                  <div class="list" v-if="item.data&&item.data[osd.value]&&item.data[osd.value].length" v-show="showStatus==osd.value">
                    <div :class="['itm', 'transition', {'active': itm.TaskNo==taskInfo.TaskNo}, {'alarm-type-2': itm.DelayedTime>0||itm.Unnormal}]" v-for="(itm, index) in item.data[osd.value]" @click="taskSwitch(itm)">
                      <i class="i-ring" v-if="itm.DelayedTime>0||itm.Unnormal"></i>
                      <div class="itno" v-text="(index+1)+'、'+itm.TaskNo"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="btn-box">
              <div class="bitm" style="display:none;"><i class="i-recall"></i><span>任务回溯</span></div>
            </div>
            <div class="dt-box">
              <div class="it-box">
                <div class="bitem titl">任务详情</div>
                <div class="bitem">
                  <div class="kv">
                    <span class="label">所属任务：</span>
                    <span class="value" v-text="taskInfo.ParentOrderNo"></span>
                  </div>
                  <div class="kv">
                    <span class="label">起始站台：</span>
                    <span class="value" v-text="taskInfo.StartStation"></span>
                  </div>
                  <div class="kv">
                    <span class="label">依赖任务：</span>
                    <span class="value" v-text="taskInfo.DependOnTask"></span>
                  </div>
                </div>
                <div class="bitem">
                  <div class="kv">
                    <span class="label">任务编号：</span>
                    <span class="value" v-text="taskInfo.TaskNo"></span>
                  </div>
                  <div class="kv">
                    <span class="label">目标站台：</span>
                    <span class="value" v-text="taskInfo.EndStation"></span>
                  </div>
                  <div class="kv">
                    <span class="label">波次号：</span>
                    <span class="value" v-text="taskInfo.WaveNo"></span>
                  </div>
                </div>
                <div class="bitem">
                  <div class="kv">
                    <span class="label">任务类型：</span>
                    <span class="value" v-text="taskInfo.TaskTypeText"></span>
                  </div>
                  <div class="kv">
                    <span class="label">任务优先级：</span>
                    <span class="value" v-text="taskInfo.Priority"></span>
                  </div>
                </div>
              </div>
              <div class="it-box yc-node" v-if="taskInfo.DelayedTime>0||taskInfo.Unnormal">
                <div class="tit">异常节点</div>
                <div class="list-node">
                  <div class="nd-block" v-for="item in taskUnusualNode">
                    <div class="nd-block-content">
                      <div class="nd-item">
                        <span class="label">站台区间：</span>
                        <span class="value" v-text="item.StationInfo"></span>
                      </div>
                      <div class="nd-item">
                        <span class="label">延时时间：</span>
                        <span class="value" v-text="Math.round(item.DelayedTime*10)/10+'min'"></span>
                      </div>
                      <div class="nd-item">
                        <span class="label">延时分析：</span>
                        <span class="value" v-text="item.Message"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="node-page" v-if="taskUnusualNodeCount > 0">
                  <span :class="[{'current': item==taskUnusualNodeIndex}]" v-for="item in Math.ceil(taskUnusualNodeCount/3)" @click="showNode(item)" v-text="item"></span>
                </div>
              </div>
              <div class="it-box progress" v-else>
                <div class="bitem titl">任务历程</div>
                <div class="bitem process">
                  <div class="pitm">
                    <i :class="['i-order-create', {'finish': taskInfo.FinishProgress}]"></i>
                    <div class="info">
                      <div :class="['text', {'finish': taskInfo.FinishProgress}]">任务创建</div>
                      <div class="dt-box">
                        <div>
                          <span class="label">预计用时:</span>
                          <span class="value" v-text="(taskInfo.TaskCreateProcess?Math.round(taskInfo.TaskCreateProcess.ExpectExpenseTime*100)/100:0)+'min'"></span>
                        </div>
                        <div>
                          <span class="label">实际用时:</span>
                          <span class="value" v-text="(taskInfo.TaskCreateProcess?Math.round(taskInfo.TaskCreateProcess.ActualTime*100)/100:0)+'min'"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pitm line">
                    <em :style="{width: (taskInfo.FinishProgress?100:0)+'%'}"></em>
                  </div>
                  <div class="pitm">
                    <i :class="['i-device-send', {'finish': taskInfo.FinishProgress}]"></i>
                    <div class="info">
                      <div :class="['text', {'finish': taskInfo.FinishProgress}]">下发设备</div>
                      <div class="dt-box">
                        <div>
                          <span class="label">预计用时:</span>
                          <span class="value" v-text="(taskInfo.DeleveryEquiment?Math.round(taskInfo.DeleveryEquiment.ExpectExpenseTime*100)/100:0)+'min'"></span>
                        </div>
                        <div>
                          <span class="label">实际用时:</span>
                          <span class="value" v-text="(taskInfo.DeleveryEquiment?Math.round(taskInfo.DeleveryEquiment.ActualTime*100)/100:0)+'min'"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pitm line active">
                    <em :style="{width: (taskInfo.FinishProgress?taskInfo.FinishProgress:0)+'%'}"></em>
                    <div class="up-tips unnormal" v-if="taskInfo.UnNormal||taskInfo.DelayedTime>0">
                      <div><span v-text="taskInfo.FinishProgress?taskInfo.FinishProgress:0"></span>%</div>
                      <div>延时：<span v-text="Math.round(taskInfo.DelayedTime*100)/100"></span>min</div>
                    </div>
                    <div class="up-tips normal" v-else>
                      <div><span v-text="taskInfo.FinishProgress?taskInfo.FinishProgress:0"></span>%</div>
                    </div>
                    <!-- <div class="down-tips unnormal">正在入库</div> -->
                  </div>
                  <div class="pitm">
                    <i :class="['i-device-finish', {'finish': taskInfo.FinishProgress&&taskInfo.FinishProgress==100}]"></i>
                    <div class="info">
                      <div :class="['text', {'finish': taskInfo.FinishProgress&&taskInfo.FinishProgress==100}]">设备执行完成</div>
                      <div class="dt-box">
                        <div>
                          <span class="label">预计用时:</span>
                          <span class="value" v-text="(taskInfo.EquimentExcuteFinish?Math.round(taskInfo.EquimentExcuteFinish.ExpectExpenseTime*100)/100:0)+'min'"></span>
                        </div>
                        <div>
                          <span class="label">实际用时:</span>
                          <span class="value" v-text="(taskInfo.EquimentExcuteFinish?Math.round(taskInfo.EquimentExcuteFinish.ActualTime*100)/100:0)+'min'"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pitm line">
                    <em :style="{width: (taskInfo.FinishProgress&&taskInfo.FinishProgress==100?100:0)+'%'}"></em>
                  </div>
                  <div class="pitm">
                    <i :class="['i-order-finish', {'finish': taskInfo.FinishProgress&&taskInfo.FinishProgress==100}]"></i>
                    <div class="info">
                      <div :class="['text', {'finish': taskInfo.FinishProgress&&taskInfo.FinishProgress==100}]">任务完成</div>
                      <div class="dt-box">
                        <div>
                          <span class="label">预计用时:</span>
                          <span class="value" v-text="(taskInfo.TaskFinishProcess?Math.round(taskInfo.TaskFinishProcess.ExpectExpenseTime*100)/100:0)+'min'"></span>
                        </div>
                        <div>
                          <span class="label">实际用时:</span>
                          <span class="value" v-text="(taskInfo.TaskFinishProcess?Math.round(taskInfo.TaskFinishProcess.ActualTime*100)/100:0)+'min'"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-block">
      <div class="item">
        <img :src="'/static/theme-green/images/order/rwjsl.png'" class="titl">
        <div class="chart-box">
          <v-chart :options="options_rwjsl" />
        </div>
        <div class="bottom-box">
          <table>
            <tbody>
              <tr>
                <td width="25%">
                  <div>平均用时</div>
                  <div class="time"><span v-text="rwjslList.AverageTime?rwjslList.AverageTime:0"></span>min</div>
                </td>
                <td>
                  <div class="time">最短用时：<span v-text="$handleNumber(rwjslList.ShortestTime)+' min'" :title="rwjslList.ShortestTime+' min'"></span></div>
                  <div class="task">任务号：<span v-text="rwjslList.ShortestTimeTaskNo" :title="rwjslList.ShortestTimeTaskNo"></span></div>
                </td>
                <td>
                  <div class="time">最长用时：<span v-text="$handleNumber(rwjslList.LongestTime)+' min'" :title="rwjslList.LongestTime+' min'"></span></div>
                  <div class="task">任务号：<span v-text="rwjslList.LongestTimeTaskNo" :title="rwjslList.LongestTimeTaskNo"></span></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="item">
        <img :src="'/static/theme-green/images/order/rwzql.png'" class="titl">
        <!-- <div class="tab-switch">
          <span v-for="item in tabData" :class="[{'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></span>
        </div> -->
        <div class="chart-box">
          <v-chart :options="options_rwzql" />
        </div>
        <div class="bottom-block">
          <div class="bd">
            <div class="itm">总任务量：<span class="dnum">{{taskTotal}}个</span></div>
            <div class="itm" v-for="item in rwzqlList">{{item.label}}：<span class="dnum">{{item.count}}个</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props: ['theme'],
  data() {
    let taskTypes = [
      {
        value: 0,
        label: '全部任务',
      },
      {
        value: -1,
        label: '延时任务',
      }
    ];
    let taskStatusData = [
      {
        'value': 3,
        'label': '已完成'
      },
      {
        'value': 2,
        'label': '执行中'
      },
      {
        'value': 1,
        'label': '待执行'
      },
    ];
    let tabData = ['当前', '日', '周', '月'];
    return {
      orderNumber: '',
      taskNumber: '',
      taskTypes: taskTypes,
      taskStatusData: taskStatusData,
      taskCurrentType: taskTypes[0].value,
      taskInfo: {},
      taskUnusualNode: [],
      taskUnusualNodeIndex: 1,
      taskUnusualNodeCount: 0,
      showStatus: 0,
      tabData: tabData,
      tabKey: tabData[0],
      rwjslList: {},
      rwjslChartList: [],
      options_rwjsl: {},
      rwzqlList: [],
      options_rwzql: {},
      taskTotal: 0,

    }
  },
  watch:{
    $route(to, from) {
      console.log('--route--', to, from);
      this.$initPage(this);
    },
    taskInfo(val) {
      this.showNode(1);
    },
  },
  mounted() {
    this.orderNumber = this.$route.query.oid;
    this.resetData();
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    this.$initPage(this);
  },
  methods: {
    resetData() {
      console.log('--resetData--')
      //任务列表
      this.getTaskList();
      //任务及时率
      this.getRwjslList();
      //任务准确率
      this.getRwzqlList();
    },
    taskTabSwitch(item, taskInfo) {
      this.taskCurrentType = item.value;
      if(taskInfo && taskInfo.TaskNo) {
        this.taskInfo = taskInfo;
      } else {
        if(item.data && item.data[3] && item.data[3][0]) {
          this.taskInfo = item.data[3][0];
        } else if(item.data && item.data[2] && item.data[2][0]) {
          this.taskInfo = item.data[2][0];
        } else if(item.data && item.data[1] && item.data[1][0]) {
          this.taskInfo = item.data[1][0];
        } else {
          this.taskInfo = {};
        }
      }
      this.showStatus = this.taskInfo.TaskState ? this.taskInfo.TaskState : 0;
    },
    taskSwitch(item) {
      this.taskInfo = item;
    },
    statusSwitch(status, item) {
      this.showStatus = this.showStatus != status ? status : 0;
      console.log(status, item)
    },
    returnBack() {
      this.$router.push({path: '/order', query: {'oid': this.orderNumber}});
    },
    getTaskList() {
      let self = this;
      //window.ApiHost1+'/static/data/Tasks_Info.json'
      //this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Tasks_Info', {
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Tasks_Info', {

        
        // "Date": this.$formatDateTime(null, 'yyyy-MM-dd'),
        "TaskNo": "",
        "OrderNo": this.orderNumber,
        "WareHouseCode": window.PYKWareHouseCode,
        
      }, 'post', function(res) {  //success

        console.log("----------------------------------")
       console.log(JSON.stringify(res))
        console.log("----------------------------------")
        let allList = res.retData.Rows;
        let delayList = res.retData.DelayedRows;

        let idx = 0;
        let existed = false;
        let taskInfo = {};
        self.taskTypes.forEach( function(t, ti) {
          t.data = {};
          let tmplist = [];
          if(t.value == 0) {
            tmplist = allList;
          } else if(t.value == -1) {
            tmplist = delayList;
          }
          tmplist.forEach( function(l, li) {
            if(typeof(t.data[l.TaskState]) == 'undefined') {
              t.data[l.TaskState] = [];
            }
            t.data[l.TaskState].push(l);
            if(self.taskNumber && self.taskNumber == l.TaskNo) {
              idx = ti;
              existed = true;
              taskInfo = l;
            }
          });
        });
        if(self.taskNumber && !existed) {
          self.$msgAlert.warning('没有相关任务！');
        } else {
          self.taskTabSwitch(self.taskTypes[idx], taskInfo);
        }
      }, function(res) {
        //fail
        console.log("失败++++++++++++++++++++++++++++++++")
      });
    },
    showNode(idx) {
      let self = this;
      let nodeList = [];
      let len = 0;
      this.taskUnusualNodeIndex = idx;
      if(this.taskInfo && this.taskInfo.DelayedTasks_Info) {
        len = this.taskInfo.DelayedTasks_Info.length;
        this.taskInfo.DelayedTasks_Info.forEach( function(d, di) {
          if(di == (self.taskUnusualNodeIndex * 3 - 1) || di == (self.taskUnusualNodeIndex * 3 - 2) || di == (self.taskUnusualNodeIndex * 3 - 3) ) {
            nodeList.push(d);
          }
        });
      }
      this.taskUnusualNode = nodeList;
      this.taskUnusualNodeCount = len;
    },
    tabSwitch(item) {
      console.log(item)
      this.tabKey = item;
    },
    getRwjslList(){
      let self = this;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Task_Flow_TimelyRto', {
        "WareHouseCode": window.PYKWareHouseCode,
        "OrderNo": this.orderNumber,
      }, 'post', function(res) {  //success
        //console.log('--', res.retData)
        self.rwjslList = res.retData;
        self.rwjslChartList = [
          {
            label: '高于平均时间',
            value: self.rwjslList.TimelyCount,
          },
          {
            label: '低于等于平均时间',
            value: self.rwjslList.UnTimelyCount,
          },
        ];
        self.setOptionsRwjsl();
      }, function(res) {
        //fail
      });
    },
    setOptionsRwjsl() {
      let colors = this.$charts.colors.style_7;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];

      this.rwjslChartList.forEach( function(d, di) {
        let tmp = {
          value: d.value,
          name: d.label+'：'+d.value+'个',
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: colors[di]
                  },
                  per: {
                    color: colors[di]
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: colors[di]
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_rwjsl = {
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 30
            },
            label: {
              normal: {
                  formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  //backgroundColor: '#061445',
                  padding: 0,
                  //borderColor: '#5165b7',
                  //borderWidth: 1,
                  rich: {
                    /*hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },*/
                    b: {
                      fontSize: 24,
                      color: chartsConf.series.color,//'#fff',
                      //padding: [0, 0, 0, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 30,
                      //padding: [0, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },
    getRwzqlList() {
      let self = this;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Tasks_PrecisionRto', {
        "WareHouseCode": window.PYKWareHouseCode,
        "OrderNo": this.orderNumber,
      }, 'post', function(res) {  //success
        self.taskTotal = res.retData.NormalCount + res.retData.UnNormalCount;
        self.rwzqlList = [
          {
            label: '系统错误',
            count: res.retData.UnNormalCount
          },
          {
            label: '准确率',
            count: res.retData.NormalCount
          },
        ];
        self.setOptionsRwzql();
      }, function(res) {
        //fail
      });
    },
    setOptionsRwzql() {
      let colors = this.$charts.colors.style_6;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let sdata = [];
      this.rwzqlList.forEach( function(d, di) {
        legendData.push(d.label);
        let tmp = {
          value: d.count,
          name: d.label,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: colors[di]
                  },
                  per: {
                    color: colors[di]
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: colors[di]
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_rwzql = {
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)",
          textStyle: {
            fontSize: 24
          }
        },
        series: [
          {
            type:'pie',
            radius: '57%',
            center: ['50%', '50%'],
            //avoidLabelOverlap: true,
            labelLine: {
              normal: {
                //show: false
              },
              //length: 30,
              length2: 20
            },
            label: {
              normal: {
                //show: false,
                //formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                formatter: '{b|{b}}：{per|{d}%}',
                //backgroundColor: '#061445',
                //padding: [6, 10, 6, 10],
                //borderColor: '#5165b7',
                //borderWidth: 1,
                rich: {
                  /*hr: {
                    //borderColor: '#fff',
                    width: '100%',
                    borderWidth: 0.5,
                    height: 0,
                  },*/
                  b: {
                    fontSize: 20,
                    color: '#000',//'#fff',
                    //padding: [0, 0, 0, 0]
                  },
                  per: {
                    align: 'center',
                    fontSize: 20,
                    color: '#000',
                    //padding: [0, 0, 0, 0]
                  }
                }
              }
            },
            data: sdata
          }
        ]
      };
    },
  }
}
</script>

<style>

.container>.bd{
  height: calc(100% - 127px);
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/order/TaskDetail.vue